import type { TransferKindCard as XpaTransferKindCard } from "@motain/xpa-proto-files-web/lib/types/transfer_kind_card";
import type { FC } from "react";
import { isNullable } from "@/types/isNullable";
import { TransferBetweenClubs } from "@/xpa-components/transfer-kind-card/transfer-between-clubs/TransferBetweenClubs";
import { TransferRenewal } from "@/xpa-components/transfer-kind-card/transfer-renewal/TrasnferRenewal";

export const TransferKindCard: FC<XpaTransferKindCard> = (props) => {
  const { state } = props;

  if (isNullable(state)) {
    return null;
  }

  switch (state.$case) {
    case "transferCompleted":
      return (
        <TransferBetweenClubs
          {...state.transferCompleted}
          kind="completed"
        ></TransferBetweenClubs>
      );
    case "transferRumor":
      return (
        <TransferBetweenClubs
          {...state.transferRumor}
          kind="rumor"
        ></TransferBetweenClubs>
      );
    case "transferRenewal":
      return (
        <TransferRenewal
          {...state.transferRenewal}
          kind={"completed"}
        ></TransferRenewal>
      );
    case "transferRenewalRumor":
      return (
        <TransferRenewal
          {...state.transferRenewalRumor}
          kind={"rumor"}
        ></TransferRenewal>
      );
    default:
      return null;
  }
};
